export default __webpack_public_path__ + "static/media/nfo_card_banner_service_fund.dfc39216.svg";